import type React from 'react';

import { Link } from '@change/ds-core-ui';
import { Form, TextField } from '@change/ds-forms';

import { Translate, useI18n } from '@change-corgi/core/react/i18n';

import { useLoginEmailForm } from './hooks/useLoginEmailForm';

export const LoginEmailForm: React.FC = () => {
	const {
		data: { email, emailError, identified },
		actions: { submitStep, setStepData, changeUser },
	} = useLoginEmailForm();
	const { translate } = useI18n();

	return (
		<>
			<Form
				onSubmit={() => {
					void submitStep();
				}}
				data-testid="email-form"
				data-qa="email-form"
			>
				<TextField
					id="email"
					type="text"
					name="email"
					size="large"
					data-testid="email"
					data-qa="email"
					label={translate('corgi.login_or_signup.common.labels.email')}
					onChange={(value) => setStepData({ email: value })}
					value={email}
					isInvalid={!!emailError}
					errorMessage={emailError}
					isReadOnly={identified}
				/>
			</Form>
			{identified && (
				<div className="mt-2">
					<Link
						as="button"
						onClick={changeUser}
						data-testid="forgot-password"
						data-qa="forgot-password"
						variant="secondary"
					>
						{/* TODO rename key to non sign-specific key */}
						<Translate value="fe.components.petition_sign.not_you" />
					</Link>
				</div>
			)}
		</>
	);
};
